export default {
  language: {
    name: "中文"
  },

  // 顶部菜单、底部菜单 公共组件
  home: {
    index: "Home Page",
    products: "Products",
    application: "Applications",
    enterpriseNews: "Press Enquiries",
    aboutUS: "About US",
    aboutRJ: "About RJ",
    joinUs: "Join Us",
    callUs: "Call Us",
    exit: "Exit",
    rjActive: "Ruijie Dynamics",
    industryNews: "News",
    shoppingCart: "Shopping Cart",
    loginRegistration: "Login/Registration"
  },

  // 登录/注册页
  loginAndRegister: {
    mobileQuickLogin: "Mobile Quick Login",
    accountLogin: "Account Login",
    placeholder1: "Please enter an 11 digit phone number",
    placeholder2: "Please enter the mobile verification code",
    placeholder3: "Please enter your phone number",
    placeholder4: "Please set password",
    placeholder5: "Please enter the verification code",
    sendVerificationCode: "Send Code",
    retrieve: "Retrieve",
    logOn: "Log On",
    clickingToLogInMeansYouAgree: "Clicking Sign in means you agree",
    userRegistrationAgreement: "User Registration Protocol",
    privacyPolicy: "Privacy Policy",
    otherLoginMethods: "Other Login Methods",
    password: "Password",
    automaticLogon: "Automatic Logon",
    freeRegistration: "Free Registration",
    forgotPassword: "Forgot Password?",
    register: "Register ",
    registering: "Registering",
    existingAccountLogInNow: "Existing account, Log in now",
    loggingIn: "Logging In",
    obtainVerificationCode: "Send Code",
    iHaveReadAndAgree: "I have read and agree",
    close: "Close",
    seconds: "Seconds",
    //移动端
    mobileAccountLogin: "Mobile Account Login",
    accountPasswordLogin: "Account Password Login",
    pleaseEnterPassword: "Please enter password",
    signUpNow: "Sign up Now",
    smsLogin: "SMS Login",
    mobileText1: "Welcome to Ruijie Innovation!",
    mPlaceholder1: "Please enter your user account",
    mPlaceholder1: "Please enter the user password again",
    clickingRegisterMeansYouAgree: "Clicking Register means you agree"
  },
  // 首页
  index: {
    applicationUse: "Product Applications",
    callUs: "Contact Us",
    aboutRJ: "About RJ",
    more: "View More",
    companyYear: "Establishment of the company",
    companyPerson: "R&D staff",
    companyCustom: "Corporate Clients",
    placeholderUserName: "Please enter your name",
    placeholderCompanyName: "Please enter the company name",
    placeholderUserPhone: "Please enter your phone number",
    placeholderRemark: "Please enter a comment",
    formSubmit: "Submit",
    companyProfile: "Company Profile"
  },

  // 产品分类页面
  products: {
    all: "ALL",
    totel: "Sum",
    piece: "Piece",
    yuan: "yuan"
  },

  // 产品信息页面
  productInfo: {
    products: "Products",
    applicationDescription: "Application Description",
    productManual: "Product Manual",
    download: "Download ",
    details: "Details",
    buyNOW: "BUY NOW",
    addToShoppingCart: "Add Shopping",
    contactUs: "Contact Us",
    price: "Price",
    selectType: "Select Type",
    submit: "Submit",
    ruijieInnovation: "Ruijie Innovation",
    // 移动端
    service: "Service ",
    providedByRuijieForTechnicalSupportServices:
      "Provided by Ruijie for technical support services",
    select: "Select",
    purchaseQuantity: "Purchase Quantity",
    selectPpecifications: "Select Specifications"
  },
  // 新闻资讯页面
  enterpriseNews: {
    enterpriseNews: "News and information",
    menuItem1: "Ruijie Dynamics",
    menuItem2: "News"
  },

  // 新闻详情页面
  newConent: {
    index: "Home Page",
    menuItem1: "Ruijie Dynamics",
    menuItem2: "News"
  },

  // 关于我们
  aboutUS: {
    aboutUS: "Contact Us",
    aboutRj: "Contact Ruijie",
    joinUs: "Join us",
    callUs: "Contact Us",
    aboutUSItem: {
      tab1Name: "Company Profile",
      tab2Name: "Development History",
      tab3Name: "Technology",
      tab4Name: "Production Capacity",
      tab5Name: "Partners",
      tab6Name: "Corporate Culture",
      tab1Text1:
        "EXTREME POWER TECHNOLOGY CO., LIMITED is committed to being the leader in drone, robotics and smart device parts",
      tab1Text2: `Shenzhen Ruijie Innovation Technology Co., Ltd. is a high-tech enterprise specializing in providing solutions for robot components. Core R&D personnel have been in the industry for many years and have a certain level of technical accumulation;
                  The company has achieved certain technological achievements in GNSS positioning, brushless motor control, laser ranging, intelligent battery technology, camera image transmission, pan tilt, data transmission, and other fields, and its products have gained a certain market share in the industry.
                  The company is committed to providing safe, reliable, and cost-effective components for the rapid development of the robotics industry; And make robot products platform and modular.`,
      tab1Text3: `We insist on designing and developing products in the spirit of geeks, the core business philosophy of "user-centered and striver-oriented", the team spirit of "hard work, unity and cooperation, honor and disgrace together, never give up", and the team spirit of "integrity, responsibility, passion, and innovation". The core values of "integrity, responsibility, passion, dedication, thinking and innovation".`,

      tab2Text1: `While the old products are steadily being shipped, new projects continue to improve, and smart battery projects, RTK projects, and data transmission projects are gradually entering trial production and small-scale mass production.
                  In the same year, the company continued to increase research and development investment, established a camera image transmission APP project team, and entered the field of robot image vision and transmission;
                  And reached strategic cooperation with multiple chip manufacturers.`,
      tab2Text2: `GNSS positioning module, laser ranging module, brushless motor control board, three carriages driving side by side, constantly iterating.
                  While achieving product diversification, the company actively expands its talent, adds new testing equipment, improves product processes, and strengthens product quality;
                  Continuing to innovate synchronously, projects such as intelligent battery management+fast charging, RTK fixed station+mobile station, and data transmission have been successively initiated and developed.`,
      tab2Text3: `The success of laser ranging modules and motor control boards has given the company a taste of sweetness on the path of innovation. In the same year, laser ranging modules achieved over 100000 shipments and motor control boards achieved over 400000 shipments;
                  In the same year, the RTK project was approved and achieved mass production and shipment.`,
      tab2Text4: `After years of customer accumulation and market cultivation, combined with market demand, a laser ranging module was developed at the beginning of the same year to add obstacle avoidance functions to products such as drones and robots.
                  By the end of the year, the laser ranging module was put into mass production; At the end of the same year, a brushless motor control board was developed to solve the pain points of high long-term costs and insufficient performance in the industry.`,
      tab2Text5: `After three years of customer accumulation and deep market cultivation, combined with market demand, development; Laser obstacle avoidance module, adding obstacle avoidance function to drones, achieving mass production by the end of the year`,
      tab2Text6: `GPS products continue to expand market share, with different software configurations tailored to different customer needs, resulting in increased stickiness between our products and customers, and also achieving a turnaround in losses and profits in the same year`,
      tab2Text7: `Ruijie Innovation was officially established in November 2015 until 2019.
                  The company has been deeply involved in GNSS positioning modules, configuring different software according to different customer needs, which has increased the stickiness of our products and customers, and achieved a large market share.`,
      tab2Text8: `Year`,
      tab2Text9: `Continue to increase research and development investment, and the PTZ project and Android remote control project have entered project approval and development.
                  Company goals for 2024: Continuous iteration of GNSS positioning module, laser ranging module, brushless motor control board, etc., and expansion of shipment volume;
                  The intelligent battery project, RTK project, and data transmission project have achieved large-scale shipment; The camera image transmission AP project achieves batch shipment.`,
      tab3Text1: `Technological leadership`,
      tab3Text2: `The first laser obstacle avoidance mode for drones`,
      tab3Text3: `Extreme Power 's innovative development of the R20 laser module is the first to replace visual obstacle avoidance on drones, significantly reducing the cost of drones.`,
      tab3Text4: `Multiple GPS applications for UAVs`,
      tab3Text5: `Drones have special requirements for GPS, and Extreme Power has developed a number of GPS modules for use in the drone market, saving customers the heavy development workload.`,
      tab3Text6: `Brushless motor ESCs are highly efficient`,
      tab3Text7: `Compared to peer brushless motor ESCs, Extreme Power 's innovative ESCs are 15-20% more efficient.  `,
      tab3Text8: `Battery Fast Charging Boards`,
      tab3Text9: `The battery fast charging protection board achieves a step up in charging efficiency over its counterpart and a 20% improvement in cost effectiveness.`,
      tab3Text10: `First domestic GPS to be used on a drone`,
      tab3Text11: `The US blockade of Chinese semiconductors led to a shortage of imported GPS chips, and Extreme Power first worked with domestic GPS chips to debug GPS modules for UAV applications, and successfully achieved mass production  `,
      tab3Text12: `Technological Advancement`,
      tab3Text13: `Safety and stability`,
      tab3Text14: `High precision control`,
      tab3Text15: `Outstanding system integration and automation capabilities`,
      tab3Text16: `Excellent energy efficiency`,
      tab3Text17: `Six Business Units`,
      tab3Text18: `GPS Module Development Division`,
      tab3Text19: `General purpose GPS modules  ,RTK High Accuracy GPS Inertial Navigation Algorithms
      Algorithms for UAV applications`,
      tab3Text19_mobile: `Universal GPS module

      RTK high-precision GPS

      Inertial navigation algorithm

      Drone application algorithm`,
      tab3Text20: `Laser Module Division`,
      tab3Text21: `Single point non-visible laser    360 degree scanning laser
      Single point laser with angular output    Radar Laser Ranging`,
      tab3Text22: `Brushless Motor ESC Department`,
      tab3Text23: `Drone ESCs    Brushless boat ESC (forward and reverse)
      Crossover ESCs   High-speed vehicle ESCs`,
      tab3Text24: `Integrated Department `,
      tab3Text25: `Motorized General Department`,
      tab3Text26: `Heads Division`,
      tab3Text27: `Brushless Heads  Image Transfer`,
      tab3Text28: `Battery Smart Fast Charging Division`,
      tab3Text29: `Battery Smart Boards   Battery Fast Charging Boards  One-Three Fast Charging Adapter`,
      tab3Text30: `Core Values`,
      tab3Text31: `responsibility, integrity, innovation, thinking, dedication and passion`,
      tab3Text32: `
        Integrity forges quality Innovation wins the market We always adhere to the idea of integrity and compliance, quality wins; with the spirit of daring to innovate, we promote enterprise development and win the market. People-oriented Seeking quality Reputation Focusing on social work such as environmental protection, energy conservation and graduate employment. `,
      tab3Text33: `Future outlook`,
      tab3Text34: ` New opportunities, New markets, New technologies, New products, New values`,
      tab3Text35: `We believe that all of our staff can work together to create a brilliant future together.`,
      tab3Text36: `Team  Spirit`,
      tab3Text37: `Hard struggle ，Unity and cooperation，Honor and shame together, Never give up `,
      tab3Text38: `Hard struggle: promote the spirit of hard struggle, carry forward the tradition of hard struggle, maintain the realm of hard struggle, adhere to the value of hard struggle, is the core driving force of enterprise development.
        Unity and cooperation: Unity is strength, success lies in cooperation; the spirit of unity and cooperation is the foundation of entrepreneurship and prosperity.
        Honor and shame together: the spirit of honor and shame together with the enterprise in the critical moment of life and death is the source of the enterprise.
         Never give up: perseverance, continuous learning, to enhance the soft power of the enterprise.`,
      tab3Text39: `Mission`,
      tab3Text40: `
        We aspire to provide safe, reliable and cost-effective components for the rapid development of the UAV robotics industry; and to make UAV robotics products platformizable and modular to create an international first-class technically innovative company. `,
      tab3Text41: `Company spirit`,
      tab3Text42: `People-oriented Quality as life`,
      tab3Text43: `R&D team size`,
      tab3Text44: ``
    },
    joinUsItem: {
      tab1Name: "Talent concept",
      tab2Name: "Employee Welfare",
      tab3Name: "STAFF",
      tab4Name: "Job Application",

      tab1Row1Tit: "Only by virtue is useful, and only by virtue is important",
      tab1Row1Text:
        "Talent is the primary resource. The production of first-class products and the creation of first-class enterprises are inseparable from the cultivation of first-class talents and the construction of first-class teams. The company always adheres to the principle of using only talent and reusing only virtue. Those with virtue and talent should be reused without exception; those without talent and virtue should never be used.",
      tab1Row2Tit: "To make the best use of one's talents",
      tab1Row2Text:
        "Adhere to the principle of let professional people do professional things, and constantly improve the Talent management system, evaluation mechanism, incentive mechanism and flow mechanism. The stage is as big as the ability of outstanding talents.",
      tab1Row3Tit: "Common development and shared success",
      tab1Row3Text:
        "Employees and the enterprise grow together, develop together, and share success.",

      tab2Row1Name:
        "Resource layer construction of training system construction",
      tab2Row2Name: "Composition of training system construction",
      tab2Row3Name: "Training opportunities",
      tab2Row1Text1: "New employee guidance training",
      tab2Row1Text2: "Company Profile",
      tab2Row1Text3: "History of Enterprise Development",
      tab2Row1Text4: "Corporate Culture",
      tab2Row1Text5: "Enterprise related systems",
      tab2Row1Text6: "Workflow",

      tab2Row1Text7: "Basic job skill training",
      tab2Row1Text8:
        "The basic training courses determined based on job competence, as well as the knowledge and skills required for various levels of positions. Job transfer, job promotion and performance appraisal reflect that those who are lack of knowledge and skills need to be trained in job skills courses according to their qualifications and personal abilities.      ",
      tab2Row1Text9: "Job Skills Improvement Course",
      tab2Row1Text10:
        "A dynamic training course established based on the development trends of technology, management, and other aspects, combined with the development goals and competitive strategies of the enterprise, after conducting training analysis.",
      tab2Row1Text11: "Employee Personal Growth Training Course",
      tab2Row1Text12:
        "According to the employee's career Career development, training courses are held when the employee needs to improve.",

      tab2Row2Text1: `Resource level`,
      tab2Row2Text2: `Internal lecturer team`,
      tab2Row2Text3: `Training course system`,
      tab2Row2Text4: `Training Database`,
      tab2Row2Text5: `Employee Training Archive`,
      tab2Row2Text6: `Operational level`,
      tab2Row2Text7: `Training Needs`,
      tab2Row2Text8: `Training Plan and Budget`,
      tab2Row2Text9: `Training organization and implementation      `,
      tab2Row2Text10: `Training assessment and evaluation`,
      tab2Row2Text11: `INSTITUTIONAL LEVEL`,
      tab2Row2Text12: `Training Management System`,
      tab2Row2Text13: `Training system and process`,
      tab2Row2Text14: `The competition of modern enterprises is the competition for "talents", as knowledge and technology update at a faster pace

      To speed up, both enterprises and employees need to take a proactive attitude to meet the "Lifelong learning"

      The arrival of the generation. The company provides a comprehensive three-dimensional training system for employees, allowing new employees to

      Quickly integrate into the team, familiarize oneself with the job, and continuously improve one's own quality.`,

      tab3Text1: `Visiting robots`,
      tab3Text2: `Visiting Robot Town Activity`,

      tab4Text1: `Recruitment positions`,
      tab4Text2: `DEPARTMENT`,
      tab4Text3: `Release Date`,
      tab4Text4: `Operate`,
      tab4Text5: `Apply For`,
      tab4Text6: `Details`,
      tab4Text7: `Apply for position`,
      tab4Text8: `Full name`,
      tab4Text9: `Please enter your name`,
      tab4Text10: `phone number`,
      tab4Text11: `Please enter your phone number`,
      tab4Text12: `Upload resume`,
      tab4Text13: `支持Doc、Excal、PDF、PNG、Jpg格式简历文件, 且大小不超过5MB`,
      tab4Text14: `submit to`,
      tab4Text15: `Apply Now`,
      tab4Text16: `Job Application`
    },
    callUsItem: {
      text1: "Shenzhen Ruijie Innovation Technology Co., Ltd",
      text2: "Shenzhen Extreme Power Technology Incorporated Company",
      text3:
        "Address: B309, Donglian Building, Chuangye Er Road, Xin'an Street, Bao'an District, Shenzhen",
      text4: "zip code：518000",
      text5: "Shenzhen Headquarters",
      text6: "TEL：0755-2350 2257, 0755-2350 2189",
      //text7: "PH：13612958273(Mr. Huang)",
      //text8: "8320800981(Mr. Liu)",
      text7: "PH:13714999515(Mr. Zhang)",
      text8: "13612958273(Mr. Huang)",
      text13: "17552314320(Mr. Li)",
      text9: "South China agent",
      text10: "TEL：021-6029 9378",
      text11: "PH：18521798797(Mr.ling)",
      text12: "E-mail：ledey@shphtec.com",
      "华东分公司地址": "Address of East China Branch",
      "地址: 上海青浦区沪青平公路3908号智创天地422/428室": "Address: Room 422/428, Zhichuang Tiandi, 3908 Huqingping Road, Qingpu District, Shanghai"
    }
  },

  // 购物车页面
  shoppingCar: {
    myart: "My Cart",
    SelectAll: "Select All",
    commodityInformation: "Commodity Information",
    unitPrice: "Unit-Price",
    number: "Number",
    subtotal: "Subtotal",
    operate: "Operate",
    theShoppingCartDoesnHaveAnyProductsYetHurryUpAndMakeApurchase:
      "The shopping cart doesn't have any products yet, hurry up and make a purchase",
    goforAstroll: " Go for a stroll",
    selectedProduct: "Selected Product",
    piece: "Piece",
    amountTo: "Amount To",
    nextStep: "Next Step",
    yuan: "yuan",
    cancelAnOrder: "Cancel an Order",
    shoppingCarTitle: "Mall_ shopping Cart",
    // 移动端
    shoppingCart: "Shopping Cart",
    shoppingText: "Your shopping cart is still empty",
    goSettle: "Go Settle",
    delete: "Delete",
    edit: "Edit",
    complete: "Complete"
  },
  // 订单中心页面
  submitOrders: {
    submitOrdersTitle: "Order_ Submit Order",
    orderingInformation: "Ordering Information",
    address: "Address",
    default: "Default ",
    addNewAddress: "Add New Address",
    InvoiceInformation: "Invoice Information",
    modify: "Modify ",
    orderNotes: "Order Notes",
    commodityInformation: "Commodity Information",
    unitPrice: "Unit-Price",
    number: "Number ",
    subtotal: "Subtotal",
    distributionCosts: "Distribution Costs ",
    payableAmount: "Payable Amount",
    submitOrder: "Submit Order",
    invoiceInformation: "Invoice Information",
    invoiceType: "Type",
    notInvoicing: "Not Invoicing ",
    personalElectronicInvoice: "Personal Invoice",
    companyElectronicInvoice: "Company Invoice",
    specialInvoice: "Special Invoice",
    addressC: "Address",
    phone: "Phone",
    bank: "Bank",
    bankAccount: "Bank Account",
    mailbox: "Mailbox ",
    invoiceHeader: "Invoice",
    taxIdentificationNumber: "Tax Identification Number",
    invoiceContentPurchaseItemDetails: "Invoice Content: Purchase Details",
    submitOrdersText1:
      "The electronic invoice will be sent to your email within 3-5 working days after you submit it. Please check your email carefully",
    invoicerelatedinformation: "Invoice related information",
    submitOrdersText2:
      "Please contact online customer service for value-added invoices",
    cancellation: "Cancellation ",
    determine: "Determine",
    name: "Name",
    phoneNumber: "Number",
    zipCode: "Zip Code",
    District: "District",
    FullAddress: "Full Address",
    street: "Street",
    setAsDefaultShippingAddress: "Set as default shipping address",
    Address: "Address",
    taxNumber: "Number",
    edit: "Edit",
    add: "Add",
    deleteTheAddress: "Delete the Address",
    placeholder1: "fill consignee name",
    placeholder2: "fill phone number",
    placeholder3: "fill in postal code",
    placeholder4: "fill in the shipping address",
    placeholder5: "Please fill in the street name",
    placeholder6:
      "Fill in the selection, please negotiate with the merchant first to reach an agreement",
    placeholder7: "Please enter your email account",
    placeholder8: "Please enter the invoice header",
    placeholder9:
      "fill Taxpayer identification number or Same social credit code",
    placeholder10: "Please enter your business address",
    placeholder11: "Please enter your company phone number",
    placeholder12: "Please enter the name of the account opening bank",
    placeholder13: "Please enter your company's bank account",
    messageTitle1: "No email account entered or incorrect email account format",
    messageTitle2:
      "No invoice header entered or incorrect invoice header format",
    messageTitle3:
      "Please fill in the purchasing taxpayer identification number or the same social credit code, or the format is incorrect",
    messageTitle4:
      "No company address entered or incorrect company address format",
    messageTitle5: "No company phone input or incorrect company phone format",
    messageTitle6:
      "No input of company account bank or incorrect format of company account bank",
    messageTitle7:
      "No company bank account entered or incorrect format of company bank account",
    invoice: {
      个人电子发票: "Personal Invoice",
      公司普通发票: "Company  Invoice",
      公司专用发票: "Specific Invoice",
      不开发票: "Not Invoicing"
    },
    // 移动端
    editOrder: "Edit Order",
    coupons: "coupons",
    freightCharge: "Freight Charge",
    offers: "Offers",
    invoiceM: "Invoice",
    buyersMessage: "Buyer's message",
    writeDownYourSpecialRequirements: "Write down your special requirements",
    contactCustomerService: "Contact Customer Service",
    submit: "Submit",
    noCouponAvailable: "No coupon available",
    total: "Total",
    selectAddress: "Select Address",
    aTotalOf: "A total of",
    pieces: "pieces",
    email: "E-mail",
    mText1: "Fill in invoice information",
    mText2: "Select invoice type",
    mPlaceholder1: "Please enter your email address",
    mPlaceholder2: "Please enter the tax identification number"
  },

  // 个人资料
  userpersonalData: {
    modifiedSuccessfully: "Modified Successfully",
    cancellation: "cancellation",
    personalData: "Personal Data",
    dataCompleteness: "Data Completeness",
    medium: "Medium",
    basicInformation: "Basic Information",
    userName: "User Name",
    gender: "Gender ",
    male: "Male",
    female: "Female",
    location: "Location",
    address: "Address",
    save: "Save",
    modifyAvatar: "Modify Avatar",
    selectFile: "Select File",
    uploadFiles: "Upload Files",
    userpersonalDataText1: "JPG or PNG, with a size not exceeding 2M",
    noFileSelected: "No file selected",
    changePassword: "Change Password",
    originalPassword: "Original Password",
    obtainVerificationCode: "Obtain verification code",
    password: "Password",
    inGeneral: "norma111111111l",
    complete: "complete",
    placeholder1: "Please enter the original password",
    placeholder2: "Please enter the verification code",
    placeholder3: "Please set your new password",
    placeholder4: "Please enter the new password again",
    placeholder5: "Please enter your honorific name",
    placeholder6: "Please select your administrative region",
    placeholder7: "Please select an image first",
    placeholder8: "The upload file size cannot exceed 2M"
  },

  // 移动端订单详情
  orderDetails: {
    invoiceDetails: "Invoice Details",
    invoiceType1: "Invoice type: No invoice issued",
    invoiceType2: "Invoice type: Personal electronic invoice",
    invoiceType3: "Invoice type: Company ordinary invoice",
    invoiceType4: "Invoice type: Company specific invoice",
    email: "E-mail",
    taxNumber: "Tax Number",
    companyAddress: "Company Adress",
    phone: "Phone",
    bank: "Bank",
    bankAccount: "Bank Account",
    orderText:
      "The shipment has not been shipped yet, and the tracking number cannot be found"
  },

  // 我的账号
  myAccount: {
    personalInformation: "Personal Information",
    hereYouCanViewPersonalInformation: "Here you can view personal information",
    editProfile: "Edit Profile",
    aCCOUNT: "ACCOUNT",
    security: "Security",
    membershipLevel: "Membership Level",
    bindPhone: "Bind Phone",
    bindNow: "Bind Now",
    exit: "Exit"
  },

  // 我的订单
  myOrders: {
    myOrder: "My Order",
    search: "Search ",
    allOrders: "All Orders",
    obligation: "Obligation",
    toBeReceived: "To be Received",
    toBeEvaluated: " To be Evaluated",
    orderNumber: "Order Number",
    productNameProductNumberOrderNumber:
      "Product Name、 Product Number、 Order Number",
    coProducts: "Co Products",
    piece: "Piece",
    total: "Total",
    goMakeThePayment: "Go make the payment",
    orderDetails: "Order Details",
    cancellationOfOrder: "Cancellation of Order",
    confirmReceipt: "Confirm Receipt",
    determine: "Determine",
    cancellation: "Cancellation",
    myOrdersText1: "Are you sure you want to delete this order data?",
    statusTest: {
      待付款: "paid",
      待收货: "To be received",
      "已付款（待发货）": "Paid (to be shipped)",
      "已收货（待评价）": "Received goods",
      已评价: "Reviewed"
    },
    // 移动端
    whole: "Whole",
    completeOrder: "Complete Order",
    regularStyle: "Regular Style ",
    order: "Order",
    closeOrder: "Close Order",
    payment: "Payment",
    noOrder: "There are currently no orders available",
    common: "Common",
    gettingYourOrderData: "Getting your order data ...",
    evaluateNow: "Evaluate Now",
    deleteOrder: "Delete Order",
    全部: "全部",
    待付款: "待付款",
    待收货: "待收货",
    待评价: "待评价",
    完成订单: "完成订单",
    充值: "recharge"
  },

  // 我的收藏
  myCollection: {
    myCollection: "My Collection",
    search: "Search",
    commodityInformation: "Commodity Information",
    price: "Price",
    operate: "Operate",
    collectionTime: "Collection Time  ",
    bUYNOW: "BUY NOW",
    cancelFavorite: "Cancel Favorite",
    youHaventCollectedAnyProductsYet: "You haven't collected any products yet",
    goForAStroll: "Go for a stroll",
    productNameAndProductNumber: "Product Name 、Product Number"
  },

  // 安全中心
  securityCenter: {
    securityCenter: "Security Center ",
    securityLevel: "Security Level",
    modify: "modify",
    loginPassword: "Login password",
    mobileVerification: "Mobile Verification",
    verifyNow: "Verify Now",
    changePassword: "Change Password",
    originalPassword: "Original Password",
    obtainVerificationCode: "Obtain Code",
    newPassword: "New Password",
    inGeneral: "In General",
    complete: "complete",
    securityCenterText1:
      " We suggest that you enable all security settings to ensure the security of your account and funds",
    securityCenterText2:
      "Please change your login password frequently and do not share the same password with other accounts",
    securityCenterText3:
      "After conducting mobile phone verification, users can quickly retrieve their account password and identity verification operations, protect your account security, and timely obtain notification information such as orders and shipments",
    securityCenterText4:
      "To ensure the security of your account information, identity verification is required when changing important information in your account. Thank you for your understanding and support! Verified that the phone can be used for account balance change reminders",
    placeholder1: "Please enter the original password",
    placeholder2: "Please enter the verification code",
    placeholder3: "Please set your new password",
    placeholder4: "Please enter the new password again",
    placeholder5: "Please  your phone number"
  },
  // 收货地址
  address: {
    address: "Address",
    addShippingAddress: "Add address",
    youHaveCreated: " You have created ",
    shippingAddress: "Shipping Address",
    upTo5CanBeCreated: "Up to 5 can be created ",
    default: "Default ",
    addButtinText: "Add Address",
    name: "Name",
    phoneNumber: "Number",
    zipCode: "Zip Code",
    district: "District",
    fullAddress: "Full Address",
    street: "Street",
    setAsDefaultShippingAddress: "Set as default shipping address",
    placeholder1: "fill consignee name",
    placeholder2: "fill phone number",
    placeholder3: "fill in postal code",
    placeholder4: "fill in the shipping address",
    placeholder5: "Please fill in the street name",
    edit: "Edit",
    add: "Add",
    deleteTheAddress: "Delete the Address",
    // 移动端
    addressManagement: "Address Management",
    consignee: "Consignee",
    cellPhoneNumber: "Phone Number ",
    provincesCitiesDistricts: "Provinces and cities",
    street: "Street",
    address: "Address",
    isItDefault: "Is it default",
    addressTitle1: "You haven't added a shipping address yet",
    addressTitle2: "Are you sure to delete the address?",
    addressTitle3: "Please select a province, city or district",
    addressTitle4: "Add shipping address",
    addressTitle5: "Edit shipping address",
    submit: "Submit",
    delete: "Delete",
    mPlaceholderM1: "Please fill in the recipient's name",
    mPlaceholderM2: "Please fill in the recipient's mobile phone number",
    mPlaceholderM3: "Please fill in the street name",
    mPlaceholderM4: "Please fill in the detailed shipping address"
  },

  // 个人中心
  userPersonal: {
    homePage: "Home Page",
    personalCenter: "Personal Center",
    orderCenter: "Order Center",
    myAccount: "My Account",
    myOrder: "My Order",
    myCollection: "My Collection",
    account: "Account",
    personalData: "Personal Data",
    securityCenter: "Security Center",
    address: "Address",
    aboutRuijie: "About Ruijie",
    agreement: "Agreement",
    myAccountTitle: "Ruijie Mall_ My Account",
    myOrderTitle: "Ruijie Mall_ My order",
    myCollectionTitle: "Ruijie Mall_ My favorites",
    agreementTitle: "Ruijie Mall_ Use Protocol",
    personalCenterTitle: "Personal Center_ personal data",
    securityCenterTitle: "Personal Center_ Security Center",
    addressManagementTitle: "Personal Center_ Address Management",
    pageName: {
      我的账号: "My Account",
      我的订单: "My Order",
      我的收藏: "My Collection",
      个人资料: "Personal Data",
      安全中心: "Security Center",
      收货地址: "Address",
      使用协议: "Agreement"
    },
    // 移动端
    accountSettings: "Account Settings",
    personalData: "Personal Data",
    headSculpture: "Head Sculpture",
    nickname: "Nickname",
    personalSignature: "Personal Signature",
    gender: "Gender",
    location: "Location",
    birthday: "Birthday",
    accountSecurity: "Account Security",
    bindPhone: "Bind Phone",
    logOutAndLogIn: "Log out and log in",
    exit: "Exit",
    save: "save",
    newNickname: "New Name",
    cancel: "Cancel",
    pleaseSelectRegion: "Please select Region",
    fullAddress: "Full Address",
    changeTheName: "Change the name",
    man: "Man",
    female: "Female",
    comfirm: "Comfirm",
    logOut: "Log Out",
    settingAddressInformation: "Setting address information",
    mPlaceholder1: "Good nicknames accentuate your style",
    mPlaceholder2: "Select your gender",
    mPlaceholder3: "Please fill in the full address",

    "我的设备": "my device",
    "飞行记录": "Flight records",
    mText1:
      "You have bound your phone number. If you want to unbind it, you can go to the personal center to unbind it",
    mText2:
      "This operation will exit the current login status and clear the page cache. Do you want to continue?"
  },
  // 移动端个人中心
  persionCenter: {
    my: "My",
    myOrder: "My Order",
    viewAllOrders: "View all Orders ",
    obligation: "Obligation",
    toBeShipped: "To be Shipped",
    toBeReceived: "To be Received",
    openForComment: "Open for comment",
    refundPayment: "Refund Payment",
    address: "Address",
    customerServiceTelephoneNumbers: "Customer Service Telephone Numbers",
    mondayToSunday: "Monday to Sunday 8:00-24:00"
  },
  // 订单详情
  orderStep: {
    orderTracking: "Order Tracking",
    OrderNumber: "Order Number ",
    OrderTime: "Order Time",
    CurrentOrderStatus: "Current Order Status",
    OrderCreatedSuccessfully: "Order Created Successfully!",
    orderDetails: "Order Details",
    consigneeInformation: "Consignee Information",
    consignee: "Consignee",
    address: "Address",
    phoneNumber: "Phone Number",
    invoiceHeader: "Invoice Header",
    buyerMessage: "Buyer Message",
    paymentMethodsAndLogistics: "Payment Methods and Logistics",
    commodityList: "Commodity List",
    photographTheMerchandise: "Photograph the merchandise",
    payment: "Payment",
    shippingConfirmingReceipt: "Shipping/Confirming Receipt",
    evaluation: "Evaluation",
    orderStepText1: "The buyer has already made the payment, the order.",
    orderStepText2: "Seller has shipped, tracking number",
    logisticsCompany: "logistics company",
    logisticsInquiry: "Logistics inquiry",
    orderCancelled: "Order cancelled",
    yuan: "yuan",
    expressDeliveryMethod: "Express Delivery Method",
    invoiceInformation: "Invoice Information",
    orderType1: "Invoice Type: No Invoice Issued",
    orderType2: "Invoice Type: Personal Invoice",
    orderType3: "Invoice Type: Company Ordinary Invoice",
    orderType4: "Invoice Type: Company Specific Invoice",
    orderStatusText: {
      全部: "All",
      待付款: "Obligation",
      待发货: "Delivery",
      待收货: "Receive",
      待评价: "Evaluate",
      完成订单: "Complete",
      已完成: "Completed",
      取消订单: "Cancel Order",
      我的账号: "My Account",
      无效订单: "Invalid Order"
    },
    // 移动端
    status: "Status",
    trackingNumber: "Tracking Number",
    clickToViewLogistics: "Click to view logistics",
    payment: "Payment",
    paymentMethod: "Payment Method",
    productAmount: "Product Amount",
    coupon: "Coupon",
    payableAmount: "Payable Amount"
  },
  // 付款页面
  payment: {
    paymentTitle: "Mall_ Payment",
    paymentText1:
      "Order submitted successfully, please make payment as soon as possible!",
    paymentText2:
      "Please complete the payment within 24 hours after submitting the order, otherwise the order will be automatically cancelled.",
    payableAmount: "Payable Amount ",
    paymentMethod: "Payment Method",
    queryOrders: "Query Orders ",
    keepShopping: "Keep Shopping",
    scanToPay: "Scan to pay",
    sweepThePayment: "Sweep the payment",
    pleaseUseAlipayToScanIt: "Please use Alipay to scan it",
    pleaseUseWechatToScanIt: "Please use wechat to scan it",
    payByScanningTheQRCode: "Pay by scanning the QR code",
    resultOfRayment: "Result of payment",
    youHaveSuccessfullyPaid: "You have successfully paid",
    yuan: "yuan",
    viewPurchasedItems: "View purchased items",
    paymentFailure: "Payment Failure",
    pleaseReinitiateThePayment: "Please reinitiate the payment",
    nameOfCommodity: "Name of Commodity",
    repay: "Repay",
    payBtnText: {
      去付款: "Payment",
      待付款: "Obligation",
      订单完成: "Order Completed"
    },
    // 移动端
    paymentOrder: "Payment Order",
    payImmediately: "Pay Immediately",
    Alipay: "Alipay",
    wechat: "wechat",
    alipayScanCodePayment: "Alipay scan code payment",
    weChatScanCodePayment: "weChat scan code payment",
    paymentCompleted: "Payment Completed",
    paymentText3: "Once the payment is complete, click the button above",
    paymentText4: "Checking payment results..."
  },

  // 充值页面
  recharge: {
    "选择您的遥控器": "Select your remote control",
    "选择您的无人机": "Select your UAV"
  },

  // 弹框内文字
  confirmText: {
    submitBtn: "Determine", // 确定按钮文字
    cancelBtn: "Cancel", // 取消按钮文字
    prompt: "Prompt",
    warn: "warn",
    success: "success",
    sensitiveOperationPrompts: "Sensitive Operation Prompts",
    loginWasSuccessful: "Login was successful",
    loginHasFailed: "Login has failed",
    confirmText1:
      "This operation will delete the address. Do you want to continue?",
    confirmText2: "Please select a shipping address!",
    confirmText3: "No product information obtained",
    confirmText4: "Order submission failed!",
    confirmText5: "Please complete the recipient's name",
    confirmText6: "Please provide the recipient's contact information",
    confirmText7: "Please improve the receiving administrative area",
    confirmText8: "Please provide detailed shipping address",
    confirmText9: "No or incorrect phone number entered",
    confirmText10:
      "The order is about to be cancelled. Do you want to continue?",
    confirmText11:
      "We are about to confirm the receipt of this order. Do you want to continue?",
    confirmText12: "Please enter your phone number and verification.",
    confirmText13: "Please enter your phone number.",
    confirmText14: "Please enter the correct formatted phone number",
    confirmText15: "Please fill in the password",
    confirmText16: "Please fill in the mobile verification code",
    confirmText17: "Please read and agree《User Registration Agreement》",
    confirmText18: "Please enter your username and password",
    confirmText19: "Cancel collection successful",
    confirmText20:
      "An unknown error occurred while canceling the collection. Please try again later",
    confirmText21: "The product has been deleted",
    confirmText22:
      "At least one shopping cart item must be selected before payment can be made!",
    confirmText23: "Collection successful",
    confirmText24: "Successfully added to shopping cart!",
    confirmText25: "Please select a single item first",
    confirmText26: "Please enter your company name",
    confirmText27: "Please enter your or your company's contact information",
    confirmText28:
      "Submission successful, we have received the information you submitted. We will arrange personnel to contact you as soon as possible.",
    confirmText29: "Submission failed, please contact the administrator.",
    confirmText30: "Please choose a payment method",
    confirmText31: "Unknown error while obtaining QR code!",
    confirmText32: "Collection canceled",
    confirmText33: "The query result is empty",
    confirmText34: "Login Failed",

    // 移动端
    confirmCancel: "Confirm Cancel",
    confirmReceipt: "Confirm Receipt!",
    mConfiemText1:
      "This operation will void the order and payment cannot be initiated again. Do you want to continue?",
    mConfiemText2:
      "The order is about to be signed for and this operation is irreversible. Do you want to continue?",
    mmConfiemText3: "This feature has not been launched yet, please stay tuned",
    mmConfiemText4: "Logged Out",
    mmConfiemText5: "Unknown error, please refresh and try again",
    mmConfiemText6: "Detailed address cannot be empty",
    mmConfiemText7: "Please select your administrative region",
    mConfiemText8:
      "The profile picture has been successfully modified and will take effect after logging in again.",
    "取消订单成功!": "取消订单成功!",
    "出现一个未知错误，请尝试刷新后重试。":
      "出现一个未知错误，请尝试刷新后重试。",
    "确认收货!": "确认收货!",
    "签收成功!": "签收成功!"
  },
  bindPhone: {
    "绑定手机号": "bind phone",
    "账号信息": "account information",
  },
  deviceManage: {
    "设备流量管理": "device traffic management",
    "我的设备": "my devices",
    "详情": "details"
  },



};



// WEBPACK FOOTER //
// ./src/components/language/en.js